import React from 'react';

export default function MarketingTrustBar() {
    return (
        <div className="trust-bar">
            <p className="trust-label">Trusted by 5,000+ healthcare professionals worldwide</p>
            <div className="trust-logos">
                <span className="trust-logo">Mayo<span>Clinic</span></span>
                <span className="trust-logo">Johns Hopkins<span>Medicine</span></span>
                <span className="trust-logo">UCL<span>Institute of Neurology</span></span>
                <span className="trust-logo">Mass General<span>Hospital</span></span>
                <span className="trust-logo">Oxford<span>Neuroscience</span></span>
                <span className="trust-logo">UCSF<span>Weill Institute</span></span>
            </div>
        </div>
    );
}
